<template>
  <article v-editable="blok" class="bg-gradient-to-b from-[#F8F8F8]">
    <header class="mb-9 pt-[4.5rem] lg:pt-24">
      <div class="container mb-9 max-w-[58rem]">
        <h1 class="text-primary-800 mb-6 text-2xl font-bold lg:text-3xl">
          {{ story?.name }}
        </h1>

        <p
          v-if="blok.introduction"
          class="text-primary-800 mb-9 text-lg lg:mb-10"
        >
          {{ blok.introduction }}
        </p>

        <div
          class="text-primary-800 flex flex-wrap items-center justify-between gap-3 text-xs"
        >
          <div v-if="story?.first_published_at" class="flex items-center gap-2">
            <UiIcon icon="calendar" size="md" />
            {{ $dayjs(story.first_published_at).format('D MMMM YYYY') }}
          </div>

          <div v-if="story?.tag_list?.length" class="flex flex-wrap gap-3">
            <div
              v-for="(tag, tagIndex) in story?.tag_list"
              :key="`tag-${tagIndex}`"
              class="border-green rounded-2xl border-2 px-2 py-1"
            >
              {{ tag }}
            </div>
          </div>
        </div>
      </div>

      <div class="container max-w-[64rem] px-0 lg:px-5">
        <figure>
          <NuxtImg
            :src="blok.featuredImage.filename"
            :alt="blok.featuredImage.alt"
            width="1300"
            class="w-full"
          />

          <figcaption
            v-if="blok.featuredImage.title"
            class="mx-5 border-b-2 border-gray-300 pb-2 pt-3 text-sm text-gray-500 lg:mx-0"
          >
            {{ blok.featuredImage.title }}
          </figcaption>
        </figure>
      </div>
    </header>

    <div
      v-for="articleComponent in blok.content"
      :key="articleComponent._uid"
      :class="{
        'mx-auto': articleComponent.component === 'BlockVideo',
        'max-w-[58rem]': articleComponent.component === 'BlockRichText',
        'max-w-[64rem]':
          articleComponent.component === 'BlockMediaImage' ||
          articleComponent.component === 'BlockVideo',
        'container my-14':
          articleComponent.component === 'BlockRichText' ||
          articleComponent.component === 'BlockMediaImage',
      }"
    >
      <StoryblokComponent :blok="articleComponent" />
    </div>
  </article>

  <StoryblokComponent
    v-for="pageComponent in blok.pageContent"
    :key="pageComponent._uid"
    :blok="pageComponent"
  />
</template>

<script lang="ts" setup>
import type { ContentTypeNewsArticleStoryblok } from '@/types/storyblok'

defineProps<{
  blok: ContentTypeNewsArticleStoryblok
}>()

const { story } = storeToRefs(useCurrentStoryStore())
</script>
